export const css = {
	root: '_2R75VD-Y',
	value: 'EDcb2DBj',
	selectedIcon: '_1H4IwGtm',
	input: '_3jb-WZZT',
	inputLeading: '_1eFrHCmb',
	inputWrapper: '_3ntCEitF',
	values: '_2CnErxLI',
	hasValue: '_3DwZJ9pi',
	wrapper: '_1E9dc-RX',
	inputLeadingWrapper: 'ky_gb3gc',
	' _key': 'certwise-theme/dojo/chip-typeahead'
};

export default css;
